var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#00538f",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3848 15.0156C6.33899 15.0156 2.88477 15.6625 2.88477 18.2467C2.88477 20.83 6.31797 21.5001 10.3848 21.5001C14.4295 21.5001 17.8848 20.8533 17.8848 18.269C17.8848 15.6848 14.4516 15.0156 10.3848 15.0156Z",
    fill: "#00538f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.385 12.5542C13.1396 12.5542 15.3476 10.3177 15.3476 7.52761C15.3476 4.73754 13.1396 2.5 10.385 2.5C7.63042 2.5 5.42236 4.73754 5.42236 7.52761C5.42236 10.3177 7.63042 12.5542 10.385 12.5542Z",
    fill: "#00538f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.932d222bab56274d7b9dbc8eb52ffeab.svg";
export { ForwardRef as ReactComponent };